import React, { useState } from 'react';
import styled from 'styled-components';
import { Buttons, CancelButton, DeleteButton, FormMessage, ModalCard } from '~/components';
import { useApi, useWorkspace } from '~/contexts';
import { useIsMounted } from '~/hooks';
import { weights } from '~/styles';

const Description = styled.p`
  &:not(:last-child) {
    margin-bottom: 1rem;
  }

  span {
    font-weight: ${weights.bold};
  }
`;

export default function DisconnectCalendar({ email, onClose, onDisconnect }) {
  const api = useApi();
  const isMounted = useIsMounted();
  const { workspace } = useWorkspace();
  const [isDisconnecting, setIsDisconnecting] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  async function handleDisconnect() {
    setIsDisconnecting(true);
    setErrorMessage();

    try {
      await api.www.workspaces(workspace.id).microsoftCalendar.disconnect();

      if (typeof onDisconnect === 'function') {
        await onDisconnect();
      }
      if (typeof onClose === 'function') {
        await onClose();
      }
    } catch ({ message }) {
      setErrorMessage(message || 'There was a problem completing your request. Please try again later.');
    } finally {
      if (isMounted.current) {
        setIsDisconnecting(false);
      }
    }
  }

  return (
    <ModalCard title="Disconnect Calendar" onClose={onClose}>
      <ModalCard.Body>
        <Description>
          Ruddr will stop reading <span>{email ?? 'your Outlook calendar'}</span>, and calendar events will no longer
          appear when you track time. The time you already tracked stays as it is.
        </Description>
        <Description>You can connect your calendar again at any time from your profile.</Description>
        {errorMessage && <FormMessage.Error spaceTop>{errorMessage}</FormMessage.Error>}
      </ModalCard.Body>
      <ModalCard.Footer>
        <Buttons align="right">
          <CancelButton onClick={onClose} style={{ marginRight: 'auto' }}>
            Cancel
          </CancelButton>
          <DeleteButton isLoading={isDisconnecting} onClick={handleDisconnect} data-testid="calendar-disconnect">
            Disconnect
          </DeleteButton>
        </Buttons>
      </ModalCard.Footer>
    </ModalCard>
  );
}
